module.exports = __webpack_public_path__ + "static/img/arc_logo.0614d13d.png";